module.exports = __webpack_public_path__ + "static/img/logo-purple.cbe6a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-purple.png
// module id = 179
// module chunks = 1